// <Form>
//   <Form.Group widths='equal'>
//     <Form.Input label='First name' placeholder='First name' />
//     <Form.Input label='Last name' placeholder='Last name' />
//     <Form.Select label='Gender' options={options} placeholder='Gender' />
//   </Form.Group>
//   <Form.Group inline>
//     <label>Size</label>
//     <Form.Radio label='Small' value='sm' checked={value === 'sm'} onChange={this.handleChange} />
//     <Form.Radio label='Medium' value='md' checked={value === 'md'} onChange={this.handleChange} />
//     <Form.Radio label='Large' value='lg' checked={value === 'lg'} onChange={this.handleChange} />
//   </Form.Group>
//   <Form.TextArea label='About' placeholder='Tell us more about you...' />
//   <Form.Checkbox label='I agree to the Terms and Conditions' />
//   <Form.Button>Submit</Form.Button>
// </Form>

import Checkbox from "./Checkbox";
import Input from "./Input";
import Radio from "./Radio";
import Select from "./Select";
import DatePicker from "./DatePicker";
import PasswordInput from "./PasswordInput";

export { Checkbox, Input, Radio, Select, DatePicker, PasswordInput };

const Form = {
  Checkbox,
  Input,
  Radio,
  Select,
  DatePicker,
  PasswordInput
};
export default Form;



// WEBPACK FOOTER //
// ./client/modules/form/index.ts